"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberEditor = void 0;
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
function NumberEditor(_a) {
    var value = _a.value, onChange = _a.onChange, label = _a.label;
    var _b = __read((0, react_1.useState)(value.toString()), 2), inputValue = _b[0], setInputValue = _b[1];
    (0, react_1.useEffect)(function () {
        setInputValue(value.toString());
    }, [value]);
    var updateValue = function (newInputValue) {
        setInputValue(newInputValue);
        var newValue = parseFloat(newInputValue);
        if (!Number.isNaN(newValue) && Number.isFinite(newValue)) {
            onChange(newValue);
        }
    };
    return (react_1.default.createElement(material_1.TextField, { size: "small", label: label, fullWidth: true, inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }, InputLabelProps: { shrink: true }, value: inputValue, onChange: function (e) { return updateValue(e.target.value); } }));
}
exports.NumberEditor = NumberEditor;
